/** Custom signature-pack shape + default, shared by the request/grant forms
 * and the field component (kept out of the .tsx so fast-refresh stays happy). */
export type PackFields = {
  level: "l1" | "l2" | "l3";
  quantity: number;
  setups: number;
};

/** Signature levels currently OFFERED in the UI. We only sell L1 (SES) for
 * now — add "l2" (AES) / "l3" (QES) back here to re-enable the selector
 * options. Kept as a single source of truth so it's a one-line revert. */
export const OFFERED_PACK_LEVELS: PackFields["level"][] = ["l1"];

export const DEFAULT_PACK: PackFields = { level: "l1", quantity: 10, setups: 3 };
